import {ApiClient} from '@hconnect/apiclient'
import {useMutation, type UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import type {CreateUpdateScheduleItem} from '../api'

type Variables = {
  plantCode: string
  scheduleId: number
  scheduleItemDTO: CreateUpdateScheduleItem
}

export const useAddScheduleItemMutation = (
  options?: Omit<UseMutationOptions<void, AxiosError, Variables>, 'mutationFn'>
) =>
  useMutation<void, AxiosError, Variables>({
    ...options,
    mutationFn: async ({scheduleId, plantCode, scheduleItemDTO}) => {
      await ApiClient.axiosInstance.post<void>(`/schedules/${scheduleId}/items`, scheduleItemDTO, {
        params: {plantCode}
      })
    }
  })
